<template>
  <div class="card-container"
    @click="openDrawer(busines)">
    <div style="display: flex; align-items: center;">
      <div class="card-img">
        <img style="padding: 10px;"
          :src="busines.img? busines.img :require('@/assets/imgs/svgs/logo-default.svg')"
          alt="logo">
        <div :class="busines.active ? 'active-indicator' : 'inactive-indicator' "></div>
      </div>
      <div class="card-info">
        <span class="title-card"
          @click="selectBussines(busines)">
          {{busines.name}}
        </span>
        <span>{{busines.category}}</span>
        <span>{{ busines.city }}</span>
      </div>
    </div>

    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"/>
      </template>
      <v-list>
        <v-list-item  title="Editar" link
        @click="editBusiness(busines)"/>
        <v-list-item  :title="busines.active ? 'Bloquear' : 'Reactivar' " link
        @click="openDialogActive()"/>
        <v-list-item  title="Eliminar" link
        @click="openDialogDelete()"/>
      </v-list>
    </v-menu>

  </div>
  <add-edit-business ref="addEditModal" @refreshList="refresh"/>
  <business-drawer ref="drawerBusiness" @openEditBusiness="editBusiness"/>

  <diaog-two-options
    ref="activeDialog"
    @okBtn="activeBusines(busines)"
    :title="busines.active ?  'Bloquear negocio': 'Reactivar negocio' "
    :txtBtn="busines.active ? 'Sí, bloquear' : 'Sí, reactivar' "
    :txtBold="busines.name"
    txtOne="Colaboradores de "
    :txtTwo="busines.active
    ? ' no podrán usar la plataforma. ¿Deseas continuar?'
    : ' podrán usar nuevamente Commercia. ¿Deseas continuar?' "/>

  <diaog-two-options
    ref="deleteDialog"
    @okBtn="deleteBusines(busines)"
    title="Eliminar negocio"
    txtBtn="Sí, Eliminar"
    :txtBold="busines.name"
    txtOne="¿Deseas bloquear y eliminar a "
    txtTwo="? No podrás deshacer la acción."/>

</template>
<script>

import DiaogTwoOptions from '../dialogs/DiaogTwoOptions.vue'
import BusinessDrawer from '../drawers/BusinessDrawer.vue'
import AddEditBusiness from '../forms/AddEditBusiness.vue'
import businessApi from '@/api/businessApi'
export default {

  name: 'CommerciaVueBusinessCard',
  emits: ['refreshList'],
  components: {
    AddEditBusiness,
    BusinessDrawer,
    DiaogTwoOptions
  },
  props: {
    busines: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    selectBussines (business) {
      this.$store.dispatch('saveBusiness', business)
    },
    editBusiness (business) {
      this.$refs.addEditModal.edit(business)
    },
    async activeBusines (business) {
      if (await businessApi.changeActive(business)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    async deleteBusines (business) {
      if (await businessApi.delete(business)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    openDrawer (business) {
      this.$refs.drawerBusiness.show(business)
    },
    openDialogActive () {
      this.$refs.activeDialog.open()
    },
    openDialogDelete () {
      this.$refs.deleteDialog.open()
    },
    refresh () {
      this.$emit('refreshList')
    }
  }
}
</script>
<style scoped>
  @import '@/assets/styles/cards.css';
</style>
